import { inject, Injectable } from '@angular/core';
import { ITourOptions, TourGuideService } from './tour-guide.service';

@Injectable({ providedIn: 'root' })
export class RebrandingTourService {
  private tourGuide = inject(TourGuideService);

  /**
   * Set up Rebranding Tour
   */
  setUpRebrandingTour() {
    this.tourGuide.addStepsAndStartTour([
      {
        titleTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.REBRANDING.STEP1.TITLE',
        textTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.REBRANDING.STEP1.TEXT',
        imgUrl: 'assets/images/places_rebranding.svg',
        classes: 'bottom-left',
        buttons: [
          {
            classes: 'finish-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.FINISH',
            type: 'next',
          },
        ],
      },
    ], new ITourOptions(
        'REBRANDING_TOUR_SEEN',
        false,
        false,
    ));
  }
}
